import { AuditableEntity } from './base.model';

// ============================================
// INTERFACES PRINCIPALES
// ============================================

export interface CommercialCondition extends AuditableEntity {
  id: number;
  code: string;
  name: string;
  description: string;
  type: CommercialConditionTypeApi;
  is_active: boolean;
  type_label?: CommercialConditionTypeLabel;
}

export interface CommercialConditionFormData {
  code: string;
  name: string;
  description: string;
  type: CommercialConditionTypeApi;
  is_active: boolean;
}

// ============================================
// ENUMS
// ============================================

// Valores que maneja la API (inglés)
export type CommercialConditionTypeApi = 'upfront' | 'deferred';

// Labels para mostrar en UI (español, capitalizadas)
export type CommercialConditionTypeLabel = 'Contado' | 'Diferido';

// Mapa: API → UI
export const COMMERCIAL_CONDITION_TYPE_MAP: Record<CommercialConditionTypeApi, CommercialConditionTypeLabel> = {
  'upfront': 'Contado',
  'deferred': 'Diferido'
};

// Mapa: UI → API (para envío de formularios)
export const COMMERCIAL_CONDITION_TYPE_REVERSE_MAP: Record<CommercialConditionTypeLabel, CommercialConditionTypeApi> = {
  'Contado': 'upfront',
  'Diferido': 'deferred'
};
